import { render } from "./TablasArpu.vue?vue&type=template&id=688497a1"
import script from "./TablasArpu.vue?vue&type=script&lang=js"
export * from "./TablasArpu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__